import classNames from 'classnames'
import Tooltip from 'components/common/Tooltip'
import { ReactNode, useState } from 'react'
import { CustomColorsRef } from 'types/general'

interface FlatHeaderButtonProps {
  handleClick: () => void
  children: ReactNode
  className?: string
  tooltipLabel?: string
  isSelected?: boolean
  /** Light theme for white header (e.g. Home style); default dark theme for colored header */
  variant?: 'light' | 'dark'
}

const FlatHeaderButton = ({
  children,
  handleClick,
  className,
  tooltipLabel,
  isSelected = false,
  variant = 'dark',
}: FlatHeaderButtonProps) => {
  const [isHover, setIsHover] = useState(false)
  const isLight = variant === 'light'

  return (
    <div
      className="relative h-full flex items-center"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <button
        onClick={handleClick}
        className={classNames(
          'flex items-center px-0 py-2 font-medium transition-all duration-200 border-b-4 border-transparent text-sm outline-none focus:outline-none',
          isLight ? 'mx-0 text-imovSecondary hover:text-imovSecondaryDark' : 'mx-4 text-white',
          className
        )}
        style={
          isLight
            ? {
                borderBottomWidth: '3px',
                borderBottomStyle: 'solid',
                borderBottomColor: isSelected ? CustomColorsRef.Primary : isHover ? CustomColorsRef.Gray : 'transparent',
              }
            : {
                borderBottomWidth: '3px',
                borderBottomStyle: 'solid',
                borderBottomColor: isSelected ? CustomColorsRef.White : isHover ? CustomColorsRef.WhiteShadow : 'transparent',
              }
        }
      >
        <span className="flex">{children}</span>
      </button>
      {tooltipLabel && <Tooltip text={tooltipLabel} showTooltip={isHover} />}
    </div>
  )
}

export default FlatHeaderButton
